import { InjectionToken } from '@angular/core';

import packageInfo from '../../../../../../package.json';

export const VERSION = new InjectionToken<string>('Project version', {
  factory: () => packageInfo.version
});
